import type { DataTableFilterField } from '@/components/data-table/types'
import { field, createSchema } from '@/lib/store/schema'
import type { VisitRecord } from '../types'

/**
 * OpenStatus filter fields for the Visits v3 table. Scoped to the VISIBLE
 * columns only (details-sheet-only fields are not filterable). Used by
 * DataTableFilterControls (sidebar).
 */
export const visitsFilterFields: DataTableFilterField<VisitRecord>[] = [
  {
    label: 'Visit Date',
    value: 'visit_date',
    type: 'timerange',
    defaultOpen: true,
  },
  {
    label: 'Visit Type',
    value: 'visit_type',
    type: 'input',
    defaultOpen: true,
  },
  {
    label: 'Program',
    value: 'program',
    type: 'input',
    defaultOpen: true,
  },
  {
    label: 'Location',
    value: 'location',
    type: 'input',
    defaultOpen: true,
  },
  {
    label: 'Primary Payer',
    value: 'primary_payer',
    type: 'input',
    defaultOpen: true,
  },
  {
    label: 'Billable',
    value: 'is_billable',
    type: 'checkbox',
    defaultOpen: true,
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
]

/**
 * BYOS schema for URL serialization.
 * Field kinds mirror the filter-field types: timerange -> array(timestamp),
 * checkbox -> array(string), input -> string.
 */
export const visitsSchema = createSchema({
  visit_date: field.array(field.timestamp()).delimiter('-').default([]),
  visit_type: field.string().default(null),
  program: field.string().default(null),
  location: field.string().default(null),
  primary_payer: field.string().default(null),
  is_billable: field.array(field.string()).delimiter(',').default([]),
})

export type VisitsFilterState = typeof visitsSchema._type
